import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { ModalStep } from './useBankSelectionFlow';
import { useGetLinkedAccounts } from './useGetLinkedAccounts';
import { useGetOpenBankingStatus } from '../../../dataHelpers/OnlineAccounts/useGetOpenBankingStatus';

type OpenBankingEntrySource = 'dashboard_widget' | 'nav_icon';

export const useOpenBankingEntry = (source: OpenBankingEntrySource) => {
    const status = useGetOpenBankingStatus();
    const linkedAccounts = useGetLinkedAccounts();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        tracking.ampli.openBankingStatusWidgetDisplayed({ status, source });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openModal = () => {
        tracking.ampli.openBankingStatusWidgetActionClicked({ status, source });
        setIsModalOpen(true);
    };

    const initialStep: ModalStep =
        status === 'expiring' ? 'reconfirmConsent' : 'choose';

    return {
        status,
        openModal,
        modalProps: {
            isOpen: isModalOpen,
            onClose: () => setIsModalOpen(false),
            initialStep,
            linkedAccounts,
            trackingSource: source
        }
    };
};
